import { createRequestActionTypes } from '../../../utils/reduxUtils.js';

export const GET_VERIFY_INTEGRATION = createRequestActionTypes(
  'integration/GET_VERIFY_INTEGRATION',
);

export const ADD_INTEGRATION = createRequestActionTypes(
  'integrations/ADD_INTEGRATION',
);

export const PATCH_INTEGRATION = createRequestActionTypes(
  'integrations/PATCH_INTEGRATION',
);

export const PUT_INTEGRATION = createRequestActionTypes(
  'integrations/PUT_INTEGRATION',
);

export const DELETE_INTEGRATION = createRequestActionTypes(
  'integrations/DELETE_INTEGRATION',
);

export const REQUEST_APPOINTMENT = createRequestActionTypes(
  'integrations/REQUEST_APPOINTMENT',
);

export const OPTIONS_INSTAGRAM_ACCOUNTS = createRequestActionTypes(
  'integrations/OPTIONS_INSTAGRAM_ACCOUNTS',
);

export const GET_ADFORM_INTEGRATIONS = createRequestActionTypes(
  'integrations/GET_ADFORM_INTEGRATIONS',
);

export const GET_ADFORM_ADVERTISERS = createRequestActionTypes(
  'integrations/GET_ADFORM_ADVERTISERS',
);

export const PATCH_ADFORM_ADVERTISER = createRequestActionTypes(
  'integrations/PATCH_ADFORM_ADVERTISER',
);

export const GET_CAMPAIGN_MANAGER_USERS = createRequestActionTypes(
  'integrations/GET_CAMPAIGN_MANAGER_USERS',
);

export const GET_CAMPAIGN_MANAGER_ADVERTISERS = createRequestActionTypes(
  'integrations/GET_CAMPAIGN_MANAGER_ADVERTISERS',
);

export const PATCH_CAMPAIGN_MANAGER_SUB_ACCOUNT = createRequestActionTypes(
  'integrations/PATCH_CAMPAIGN_MANAGER_SUB_ACCOUNT',
);

export const DELETE_GOOGLE_ANALYTICS_INTEGRATION = createRequestActionTypes(
  'integration/DELETE_GOOGLE_ANALYTICS_INTEGRATION',
);

export const PUT_GOOGLE_ANALYTICS_INTEGRATION = createRequestActionTypes(
  'integration/PUT_GOOGLE_ANALYTICS_INTEGRATION',
);
